import { TabList } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface PageTabListProps extends Record<string, unknown> {
  className?: string
  buttonBar?: React.ReactNode
}

export const PageTabList = ({ className, buttonBar, ...props }: PageTabListProps) => {
  return (
    <div
      className={twMerge(
        `bg-background-secondary mb-5 flex
        w-screen  -translate-x-4 items-center justify-between px-0 
        sm:-translate-x-6 
        sm:px-6 md:-translate-x-14 md:px-14`,
        className,
      )}
    >
      <TabList className={'hide-scrollbar flex overflow-scroll'} {...props} />
      {buttonBar}
    </div>
  )
}
